/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cj_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV to JSON Converter`)
};

const es_cj_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertidor de CSV a JSON`)
};

const de_cj_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV-zu-JSON-Konverter`)
};

const nl_cj_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV naar JSON-converter`)
};

const fr_cj_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur CSV en JSON`)
};

const it_cj_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore CSV a JSON`)
};

const pt_br2_cj_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de CSV para JSON`)
};

const pt_cj_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de CSV para JSON`)
};

const ja_cj_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV から JSON コンバーター`)
};

const zh_cj_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV 转 JSON 转换器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cj_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cj_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cj_tool_name", locale)
	if (locale === "en") return en_cj_tool_name(inputs)
	if (locale === "es") return es_cj_tool_name(inputs)
	if (locale === "de") return de_cj_tool_name(inputs)
	if (locale === "nl") return nl_cj_tool_name(inputs)
	if (locale === "fr") return fr_cj_tool_name(inputs)
	if (locale === "it") return it_cj_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_cj_tool_name(inputs)
	if (locale === "pt") return pt_cj_tool_name(inputs)
	if (locale === "ja") return ja_cj_tool_name(inputs)
	return zh_cj_tool_name(inputs)
};